import ky from 'ky';

import { config } from './config.js';


let base_url = 'https://backoffice.hi-ability.eu';
let token_field = 'tk';
let endpoint = ky.create({
  prefixUrl: base_url + '/',
});

export class api {
  static base_url = base_url;
  static auth_token = undefined

  static locale = {
    "en": "en-US",
    "it": "it-IT",
    "gr": "el-GR",
    "hr": "hr-HR"
  }

  static async login(email, password) {
    if (this.auth_token == undefined) {
      let body = {
        "email": email,
        "password": password
      };
      let resp = await endpoint.post('auth/login', {json: body}).json();
      this.auth_token = resp.data.access_token;
      localStorage.setItem(token_field, resp.data.refresh_token);
    } else {
      return {data: []};
    }
  }

  static async refresh_token() {
    let refresh_token = localStorage.getItem(token_field);
    if (refresh_token != undefined) {
      let body = {
        "refresh_token": refresh_token
      };
      let resp = await endpoint.post('auth/refresh', {json: body, throwHttpErrors: false}).json();
      this.auth_token = resp.data.access_token;
      localStorage.setItem(token_field, resp.data.refresh_token);
    }
  }

  static async logout() {
    if (this.auth_token != undefined) {
      let refresh_token = localStorage.getItem(token_field);
      let body = {
        "refresh_token": refresh_token
      };
      await endpoint.post('auth/logout', {json: body}).json();
      this.auth_token = undefined;
      localStorage.removeItem(token_field);
    }
      return;
  }

  static async get_user_self() {
    if (this.auth_token != undefined) {
      let query = "?fields=first_name,last_name,email,language";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('users' + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async get_excursion(excursion_id) {
    if (this.auth_token != undefined) {
      let query = "?fields=id,date,trail_id,info,participants,equipment";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('items/excursions/' + excursion_id + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async get_excursion_data(excursion_id) {
    if (this.auth_token != undefined) {
      let query = "?fields=id,date,trail_id.title";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('items/excursions/' + excursion_id + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async get_all_my_excursions() {
    if (this.auth_token != undefined) {
      // excursions still visible after 7 days
      let week_ago = new Date();
      week_ago.setDate(week_ago.getDate() - 7);
      week_ago = week_ago.toISOString();

      let query = "?fields=excursions_id.id,excursions_id.date,excursions_id.trail_id";
      query = query + "&filter[excursions_id][date][_gte]=" + week_ago;
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('items/excursions_directus_users' + query + auth).json();
    } else {
      throw new Error('Authentication required');
    }
  }

  static async get_all_trails() {
    let query = "?fields=id,country,title,cover_image";
    query = query + "&filter[status][_eq]=published";
    return await endpoint.get('items/trails' + query).json();
  }

  static async get_trail(trail_id) {
    let lang = this.locale[config.language] || locale["en"]
    let query = "?fields=*,translations.*";
    let translation = "&deep[translations][_filter][languages_code][_eq]=" + lang;
    return await endpoint.get('items/trails/' + trail_id + query + translation).json();
  }

  static async get_fences(trail_id) {
    let lang = this.locale[config.language] || locale["en"]
    let query = "?filter[trail_id][_eq]=" + trail_id;
    query = query + "&fields=*,translations.*";
    let translation = "&deep[][translations][_filter][languages_code][_eq]=" + lang;
    return await endpoint.get('items/fences/' + query + translation).json();
  }

  static async post_feedback(excursion_id, answers) {
    let body = {
      "excursion_id": excursion_id,
      "answer_1": answers[0],
      "answer_2": answers[1],
      "answer_3": answers[2],
      "answer_4": answers[3],
      "answer_5": answers[4]
    }
    let auth = "?access_token=" + this.auth_token;
    return await endpoint.post('items/feedbacks' + auth, {json: body});
  }
}